import { useTranslation } from 'react-i18next'

import Section from '@/components/atomic/molecules/Section'
import Text from '@/components/atomic/atoms/Text'
import Button from '@/components/cell/molecules/Button'
import { useToast } from '@/hooks/Notification/toast.hook'
import { getStaticGoogleMapURL } from '@/shared/utils'
import { useLocales } from '@/shared/hooks/useLocales'

type HospitalMapProps = {
  address?: string
  lat: number
  lng: number
  onClickMap?: () => void
  onClickCopyAddress?: () => void
}

const HospitalMap = ({ address, lat, lng, onClickMap, onClickCopyAddress }: HospitalMapProps): JSX.Element => {
  const { show } = useToast()

  const { t } = useTranslation()
  const { locale } = useLocales()

  const addClipboardText = (text: string) => {
    try {
      navigator.clipboard.writeText(text)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Section title={t('templates.hospitalDetail.addressTitle')} className="addressSection">
      <div style={{ marginBottom: '24px' }} className="addressWrapper">
        <Text element="address" type="caption2">
          {address}
        </Text>
        <Button
          color="action"
          size="small"
          aria-label="copy address"
          onClick={() => {
            address && addClipboardText(address)
            onClickCopyAddress?.()
            show(t('templates.hospitalDetail.toast.copy'))
          }}
        >
          <Text type="caption2">{t('templates.hospitalDetail.buttons.copy')}</Text>
        </Button>
      </div>
      <div
        style={{
          position: 'relative',
          width: '100%',
          zIndex: 1,
        }}
        onClick={() => onClickMap?.()}
      >
        <img
          src={getStaticGoogleMapURL({ lat, lng, width: 400, height: 145, locale })}
          alt={address}
          style={{
            width: '100%',
            height: '100%',
            cursor: 'pointer',
          }}
          onClick={() => window.open(`https://www.google.com/maps?q=${lat},${lng}`)}
        />
      </div>
    </Section>
  )
}

export default HospitalMap
